

export const MenuList = {
  user: [
    {
      title: "Business",
      iconStyle: <i className="fas fa-briefcase"></i>,
      content: [
        {
          title: "Dashboard",
          to: "warehouse-dashboard",
          iconStyle: <i className="fas fa-tachometer-alt"></i>,
        },
        {
          title: "Inventory",
          classsChange: "mm-collapse",
          iconStyle: <i className="fas fa-warehouse"></i>,
          content: [
         
            // { title: "Variants", to: "vee-variant" },
            { title: "Categories", to: "vee-category" },
            { title: "Items", to: "vee-product" },
            { title: "Adjustments", to: "inventory-adjustment" },
            { title: "Reason", to: "reason-type" },

          ],
        },
        {
          title: "Sales",
          classsChange: "mm-collapse",
          iconStyle: <i className="fas fa-shopping-cart"></i>,
          content: [
            { title: "Customers", to: "customer" },
            { title: "Orders", to: "order-list" },
            { title: "Invoices", to: "invoices" },
            { title: "Packages", to: "packages" },
          ],
        },
        {
          title: "Purchases",
          classsChange: "mm-collapse",
          iconStyle: <i className="fas fa-clipboard-list"></i>,
          content: [
            { title: "Vendors", to: "vee-supplier" },
            { title: "Purchase Orders", to: "purchase-order" },
            { title: "Purchase Received", to: "grn" },
            { title: "Inventory", to: "inventory" },

            { title: "Bills", to: "bills" },
            { title: "My Expenses", to: "expenses" },
            { title: "PNL", to: "pnl-summary" },

          ],
        },

          {
          title: "Subscription",
          to: "subscription-details",
          iconStyle: <i className="fas fa-tachometer-alt"></i>,
        },
      ],
    },

    {
      title: "Sales Channels",
      iconStyle: <i className="fas fa-store-alt"></i>,
      content: [
        {
          title: "POS",
          to: "pos",
          iconStyle: <i className="fas fa-cash-register"></i>,
        },
        {
          title: "Customization",
          classsChange: "mm-collapse",
          iconStyle: <i className="fas fa-cogs"></i>,
          content: [
            { title: "Paymode Master", to: "paymode-master" },
            { title: "Cutting Master", to: "meat-cutting-instruction" },
            { title: "Expense Master", to: "expense-master" },
          ],
        },
      ],
    },

    {
      title: "Reports",
      iconStyle: <i className="fas fa-chart-line"></i>,
      content: [
        {
          title: "Sales Reports",
          classsChange: "mm-collapse",
          iconStyle: <i className="fas fa-chart-line"></i>,
          content: [
            { title: "Sales by Items", to: "sales-by-items" },
            { title: "Sales by Category", to: "sales-by-category" },
            { title: "Sales by Paymodes", to: "paymode-report" },
          ],
        },

          {
          title: "Expense Reports",
          to: "expense-reports",
          iconStyle: <i className="fas fa-cash-register"></i>,
        },
      ],
    },
  ],
};






   

   

  

